// Amazon SP-API / Login-With-Amazon consent flow. Opening this URL connects the
// user's Amazon account to Nepeto (shared solution id). `state` carries the
// user's email so the backend can link the connection back to the account.
export const getAmazonConsentUrl = (email) =>
  "https://sellercentral.amazon.com/apps/authorize/consent?application_id=amzn1.sp.solution.5e50b4d6-1a6f-46fa-a523-7dc2bd0266a8&version=beta&state=" +
  encodeURIComponent(email || "");
